import React, { useState, useEffect } from "react";
import { formatUSPhone, isValidUSPhone, toE164Phone } from "src/Common/function";

function PhoneNumberInput({
  label = "Phone",
  placeholder = "(555) 123-4567",
  value = "",
  onChange,
  onInvalidChange,
  required = false,
  showError = false,
  width,
  labelClassName = "text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-2",
  // "card": the larger field of the current card style (Account page).
  variant = "default",
}) {
  const isCard = variant === "card";
  const [display, setDisplay] = useState(formatUSPhone(value));
  const [touched, setTouched] = useState(false);
  const dirtyRef = React.useRef(false);

  useEffect(() => {
    if (dirtyRef.current) return;
    setDisplay(formatUSPhone(value));
  }, [value]);

  const handleChange = (e) => {
    const formatted = formatUSPhone(e.target.value);
    dirtyRef.current = true;
    setDisplay(formatted);
    const empty = !formatted.trim();
    const valid = isValidUSPhone(formatted);
    if (onChange) {
      onChange(valid ? toE164Phone(formatted) : "");
    }
    if (onInvalidChange) {
      onInvalidChange(!empty && !valid);
    }
  };

  const handleBlur = () => {
    setTouched(true);
  };

  const isEmpty = !display.trim();
  const invalid = !isEmpty && !isValidUSPhone(display);
  const missing = required && isEmpty;
  const showInvalid = (touched || showError) && invalid;
  const showMissing = showError && missing;
  const hasError = showInvalid || showMissing;

  return (
    <div style={width ? { width } : undefined} className={width ? "" : "w-full"}>
      {label && <p className={labelClassName}>{label}</p>}
      <div
        className={
          isCard
            ? `w-full h-[44px] border rounded-[6px] bg-white flex items-center px-3 ${
                hasError ? "border-red-500" : "border-[#E5E8F3] focus-within:border-[#73A7FF]"
              }`
            : `w-full h-[30px] border-solid border-[1px] rounded-[5px] flex items-center justify-center px-[15px] ${
                hasError ? "border-red-500" : ""
              }`
        }
      >
        <input
          value={display}
          type="tel"
          onChange={handleChange}
          onBlur={handleBlur}
          className={
            isCard
              ? "w-full font-OpenSansRegular text-[14px] leading-[20px] tracking-[0.14px] text-[#1A2332] bg-transparent outline-none"
              : "w-full text-inputEmailTitle text-[11px] font-[400] font-OpenSansMedium bg-transparent outline-none"
          }
          placeholder={placeholder}
        />
      </div>
      {showInvalid && (
        <p className={`text-red-500 font-OpenSansMedium mt-1 ${isCard ? "text-[12px]" : "text-[10px]"}`}>
          Please enter a valid phone number
        </p>
      )}
      {showMissing && !showInvalid && (
        <p className={`text-red-500 font-OpenSansMedium mt-1 ${isCard ? "text-[12px]" : "text-[10px]"}`}>
          Phone number is required
        </p>
      )}
    </div>
  );
}

export default PhoneNumberInput;
